import { FunctionComponent, PropsWithChildren } from 'react';

export const TableBody: FunctionComponent<PropsWithChildren> = ({
  children,
}) => <tbody className="bg-white">{children}</tbody>;
